import { initialUnits, UnitList } from "./UnitList";

type ApartmentListProps = {
  onApartmentHover?: (apartmentInfo: {id: string; floor: number} | null) => void;
  onApartmentClick?: (apartmentInfo: {id: string; floor: number}) => void;
};

export function ApartmentList({ onApartmentHover, onApartmentClick }: ApartmentListProps): JSX.Element {
  return (
    <div className="bg-[#ffffffa1] rounded-2xl w-full p-4 flex flex-col h-full">
      <div className="flex flex-col w-full items-start flex-shrink-0">
        <h3 className="text-xl font-light tracking-wide">Blue Horizon Complex</h3>
        <div className="my-2"></div>
        <p className="text-black text-sm">
          {initialUnits.length} <span className="font-extralight">Units</span>
        </p>
      </div>
      <div className="flex-1 min-h-0 mt-4">
        <UnitList onApartmentHover={onApartmentHover} onApartmentClick={onApartmentClick} />
      </div>
    </div>
  );
}

export default ApartmentList;
